import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-xl font-semibold text-gray-800" }
const _hoisted_2 = { class: "flex items-center space-x-4" }
const _hoisted_3 = { class: "grid grid-cols-1 gap-4 md:grid-cols-3" }

import { computed, reactive, Ref, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import { AxiosResponse } from 'axios';

import { useVuelidate, Validation, ValidationArgs } from '@vuelidate/core';
import { required, maxLength } from '@/utils/validators';

import { useUiStore } from '@/stores';
import { goBack } from '@/composables/useNavigation';
import { LevelService } from '@/services';
import { toast, toastServiceError } from '@/services/core/notification';

import { Permission, FormAction, LevelModel, LevelFormState } from '@/types';


export default /*@__PURE__*/_defineComponent({
  __name: 'LevelFormPage',
  props: {
    action: { type: String, default: FormAction.CREATE },
},
  setup(__props) {

const uiStore = useUiStore();
const route = useRoute();

const props = __props;

const formState = reactive<LevelFormState>({
    name: null,
    isActive: true,
});

const rules = computed<ValidationArgs<LevelFormState>>(() => ({
    name: { required, maxLength: maxLength(500) },
    isActive: { required },
}));

const v$: Ref<Validation<ValidationArgs<LevelFormState>>> = useVuelidate(rules, formState);

const setLoading = (loading: boolean) => uiStore.setIsLoading(loading);

const fetchLevel = async (id: number) => {
    try {
        setLoading(true);
        const { data } = await LevelService.get<LevelModel>(id);
        formState.name = data.name;
        formState.isActive = data.isActive;
    } catch (e) {
        toastServiceError(e);
    } finally {
        setLoading(false);
    }
};

const onSubmit = async () => {
    const isFormValid = await v$.value.$validate();
    if (!isFormValid) return;

    setLoading(true);

    const handleServiceSuccess = (message: string, id: number) => {
        toast.success(message);
        v$.value.$reset();
        goBack({ name: 'ViewLevelById', params: { id } });
    };

    try {
        if (props.action === FormAction.EDIT) {
            const id = Number(route.params.id);
            const { data }: AxiosResponse = await LevelService.update(id, formState);
            handleServiceSuccess(data.message, id);
        } else {
            const { data }: AxiosResponse = await LevelService.create(formState);
            handleServiceSuccess(data.message, data.result.id);
        }
    } catch (e) {
        toastServiceError(e);
    } finally {
        setLoading(false);
    }
};

onMounted(async () => {
    if (props.action === FormAction.EDIT) {
        const levelId = Number(route.params.id);
        if (!isNaN(levelId)) fetchLevel(levelId);
    }
});

return (_ctx: any,_cache: any) => {
  const _component_UiBackButton = _resolveComponent("UiBackButton")!
  const _component_UiButton = _resolveComponent("UiButton")!
  const _component_UiPageHeader = _resolveComponent("UiPageHeader")!
  const _component_UiTextInput = _resolveComponent("UiTextInput")!
  const _component_UiCheckboxInput = _resolveComponent("UiCheckboxInput")!
  const _component_UiPanel = _resolveComponent("UiPanel")!
  const _component_UiCheckDirtyBeforeRouteLeave = _resolveComponent("UiCheckDirtyBeforeRouteLeave")!

  return (_openBlock(), _createElementBlock("form", {
    class: "space-y-4 p-4 sm:p-6 lg:p-8",
    autocomplete: "off",
    onSubmit: _withModifiers(onSubmit, ["prevent"])
  }, [
    _createVNode(_component_UiPageHeader, null, {
      info: _withCtx(() => [
        _createElementVNode("h1", _hoisted_1, _toDisplayString(_ctx.$t('level.' + props.action + '.title')), 1)
      ]),
      actions: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_UiBackButton, { fallbackTo: { name: 'ListLevel' } }),
          (
                            (props.action == _unref(FormAction).CREATE && _ctx.$can(_unref(Permission).CREATE_LEVEL)) ||
                            (props.action == _unref(FormAction).EDIT && _ctx.$can(_unref(Permission).EDIT_LEVEL))
                        )
            ? (_openBlock(), _createBlock(_component_UiButton, {
                key: 0,
                type: "submit",
                variant: "primary",
                "text-variant": "white"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('core.actions.Save')), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_UiPanel, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_UiTextInput, {
            modelValue: _unref(v$).name.$model,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(v$).name.$model) = $event)),
            name: "name",
            type: "text",
            label: _ctx.$t('level.labels.name'),
            errors: _unref(v$).name.$errors,
            onBlur: _unref(v$).name.$touch
          }, null, 8, ["modelValue", "label", "errors", "onBlur"]),
          _createVNode(_component_UiCheckboxInput, {
            modelValue: _unref(v$).isActive.$model,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(v$).isActive.$model) = $event)),
            name: "isActive",
            label: _ctx.$t('level.labels.isActive'),
            class: "md:pt-6"
          }, null, 8, ["modelValue", "label"])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_UiCheckDirtyBeforeRouteLeave, {
      dirty: _unref(v$).$anyDirty
    }, null, 8, ["dirty"])
  ], 32))
}
}

})